import { usePagination } from "./use-paginations";
import { SearchFilesParamsEntryType, useSearchQuery } from "@/api/files";

interface DriveSearchParams {
  folderId?: string | undefined;
  query: string;
  entry_type: SearchFilesParamsEntryType[];
  only_shared?: boolean;
}

export const useDriveSearch = ({ folderId, query, entry_type, only_shared }: DriveSearchParams) => {
  const {
    isLoading,
    isFetching,
    data: displayItems,
    error,
  } = useSearchQuery({ fse_id: folderId, query, entry_type, only_shared });

  const pagination = usePagination(displayItems || []);

  return {
    isLoading,
    error,
    isFetching,
    ...pagination,
    data: displayItems,
  };
};
